export const stripe = {
  subTitle:
    "Połącz swoje konto Stripe, aby szybko i wygodnie obciążać klientów za rezerwacje i uniknąć prowizji biur podróży online.",
};
